import ReactGA from 'react-ga';

const initGA = () => {
  // @ts-expect-error Extended window
  if (!window.GA_INITIALIZED) {
    const fields: { userId?: string } = {};
    const storageAuthData = getItem('ngStorage-authData');
    if (storageAuthData) {
      const authData = JSON.parse(storageAuthData) as { uid?: string };
      if (authData.uid) {
        fields.userId = authData.uid;
      }
    }
    ReactGA.initialize(`${process.env.GOOGLE_ANALYTICS_ID as string}`, {
      gaOptions: { ...fields },
    });
    // @ts-expect-error Extended window
    window.GA_INITIALIZED = true;
  }
};

export function getItem(name: string) {
  try {
    if (typeof localStorage === 'object') {
      return localStorage.getItem(name);
    }
  } catch (error) {
    // ignore
  }
  return undefined;
}

export const logPageView = () => {
  initGA();

  const page = `${window.location.pathname}${window.location.search}`;
  ReactGA.set({ location: window.location.href, page });
  ReactGA.pageview(page);
};

export const logEvent = (category = '', action = '', label = '') => {
  if (category && action) {
    initGA();
    ReactGA.event({ action, category, label });
  }
};

export const logException = (description = '', fatal = false) => {
  if (description) {
    initGA();

    ReactGA.exception({ description, fatal });
  }
};

export const setFields = (fields = {}) => {
  initGA();

  ReactGA.set(fields);
};

const GA_CATEGORY_REQUEST_DASHBOARD = 'Dashboard';
export const getRequestDashboardCategory = (type: 'client' | 'pro') =>
  `${GA_CATEGORY_REQUEST_DASHBOARD}:${type}`;
export const makeGARequestIdLabel = (requestId?: string) =>
  `${requestId ? `requestId:${requestId} ` : ''}`;
